export function checkNumberPlus(val,change,maxValue){
    let nowval = parseInt(val)+change;
    if(!nowval||nowval<0){
        nowval = 0;
    }else if(nowval>maxValue){
        nowval = maxValue;
    }
    return nowval;
}
export function checkMoneyPlus(val,change,maxValue){
    let arr = val.split('.');
    let nowval = 0;
    if(arr.length>=2){
        if(arr[1].length>2){
            arr[1]=arr[1].slice(0,2);
        }
        nowval = (parseInt(arr[0])+change)+"."+arr[1];
    }else{
        nowval = parseInt(val)+change;
    }
    if(!nowval||nowval<0){
        nowval = 0;
    }else if(nowval>maxValue){
        nowval = maxValue;
    }
    return nowval;
}